import React from 'react';

import { useSelector } from 'react-redux';

import ButtonGroup from '@atlaskit/button/button-group';

import {
  getIsCurrentPullRequestOpen,
  getHasCurrentUserApprovedPr,
} from 'src/redux/pull-request/selectors';

import ApprovalButton from '../../containers/approval-button';

import approvalMessages from './approval-button.i18n';
import * as styles from './header-actions.style';
import { OpenPullRequestActions } from './open-pull-request-actions';

export const ReviewerActions = ({
  isHeaderSticky,
  tabIndex,
}: {
  isHeaderSticky?: boolean;
  tabIndex: number;
}): JSX.Element => {
  const isOpenPr = useSelector(getIsCurrentPullRequestOpen);
  const hasApproved = useSelector(getHasCurrentUserApprovedPr);
  const Wrapper =
    isHeaderSticky || !isOpenPr
      ? React.Fragment
      : styles.WhiteBackgroundWrapper;
  return (
    <Wrapper>
      <ButtonGroup>
        {isOpenPr && <OpenPullRequestActions tabIndex={tabIndex} />}
        {(isOpenPr || !hasApproved) && (
          <ApprovalButton
            messages={approvalMessages}
            removeLeftBorderRadius={isOpenPr}
            tabIndex={tabIndex}
          />
        )}
      </ButtonGroup>
    </Wrapper>
  );
};
